export default {
  // Errors
  cantMoveFolderToItself: 'شما نمی توانید یک پوشه را به داخل خودش انتقال دهید.',

  // Words
  copy: 'کپی',
  createFolder: 'ایجاد پوشه',
  cut: 'بریدن',
  fileName: 'نام فایل',
  folder: 'پوشه',
  folderName: 'نام پوشه',
  loading: 'در حال بارگیری',
  mediaGallery: 'گالری رسانه',
  newName: 'نام تازه',
  paste: 'چسباندن',
  remove: 'حذف',
  rename: 'ویرایش نام',
  type: 'نوع',
  upload: 'بارگذاری'
}
